import { render, staticRenderFns } from "./BrandCreate.vue?vue&type=template&id=4de0e545&scoped=true&"
import script from "./BrandCreate.vue?vue&type=script&lang=js&"
export * from "./BrandCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de0e545",
  null
  
)

export default component.exports